export const generateSchema = (inputs) => {
  const required = inputs.reduce((p,c) => c.required ? [...p, c.name] : p,[])
  
  const properties = inputs.reduce((p,c) => {
    if (!c.required && !c.spec) {
      return p
    } else if (c.required && !c.spec && c.type === 'DAGFileInput'){
      // required field with no schema
      return ({
        ...p,
        [c.name]: {
          'type': 'object',
        }
      })
    } else if (c.required && !c.spec){
      // required field with no schema
      return ({
        ...p,
        [c.name]: {}
      })
    }
    return ({
      ...p,
      [c.name]: {
        ...c.spec,
      }
    })
  }, {})

  required.push('study-name')
  properties['study-name'] = { 'type' : 'string', minLength: 1 }

  return({ 
    type: 'object', 
    properties, 
    required, 
    additionalProperties: true
  })
}